import React from 'react';
import { observer } from 'mobx-react';
import { Box } from '@mui/material';
import { DialogSummaryProps } from './types';
import getFieldKey from '50.quickConnect.Fields/helpers/getFieldKey';
import DialogSummaryItem from '50.quickConnect.Fields/FieldsTypes/Containers/DialogQcField/DialogSummary/DialogSummaryItem';
import {
  DialogSummaryItemsStyle,
  DialogSummaryStyle,
} from '50.quickConnect.Fields/FieldsTypes/Containers/DialogQcField/styles';
import useData from '50.quickConnect.Fields/FieldsTypes/Containers/DialogQcField/DialogSummary/hooks';

const DialogSummary = ({ items, parentId, isReadOnly }: DialogSummaryProps) => {
  const { nameWithId, hasItemsToDisplay, itemsToDisplay } = useData(items, parentId);

  if (itemsToDisplay.length === 0) return <></>;

  return (
    <Box sx={hasItemsToDisplay ? DialogSummaryStyle(isReadOnly) : {}}>
      <Box data-cy={nameWithId} sx={DialogSummaryItemsStyle}>
        {itemsToDisplay.map((item) => {
          const key = getFieldKey(item);
          const { summaryLabel, mandatory, errors } = item;

          return (
            <DialogSummaryItem
              key={key}
              parentId={parentId}
              label={summaryLabel}
              mandatory={mandatory}
              errors={errors}
            />
          );
        })}
      </Box>
    </Box>
  );
};
export default observer(DialogSummary);
